/**
 * Hook simple para cargar imagenes en Konva. No usamos la libreria 'use-image'
 * para no agregar dep extra; este re-implementa lo mismo.
 */
import { useEffect, useState } from 'react';

export default function useImage(src, crossOrigin) {
  const [state, setState] = useState({ image: undefined, status: 'loading' });

  useEffect(() => {
    if (!src) {
      setState({ image: undefined, status: 'failed' });
      return;
    }
    const img = new window.Image();
    if (crossOrigin) img.crossOrigin = crossOrigin;
    const onLoad = () => setState({ image: img, status: 'loaded' });
    const onError = () => setState({ image: undefined, status: 'failed' });
    img.addEventListener('load', onLoad);
    img.addEventListener('error', onError);
    img.src = src;
    return () => {
      img.removeEventListener('load', onLoad);
      img.removeEventListener('error', onError);
    };
  }, [src, crossOrigin]);

  return [state.image, state.status];
}
